/**
 * Joins conditional class names. CSS Modules' generic ambient type gives
 * every `styles[key]` access the type `string | undefined` (there's no way
 * for the type to know which keys a given `.module.css` file really has),
 * which a template literal can't interpolate directly under this project's
 * strict lint config — `cx` sidesteps that without discarding the
 * possibly-`undefined` type via an assertion.
 */
export function cx(...classNames: (string | undefined | false)[]): string {
  return classNames.filter((c): c is string => Boolean(c)).join(' ')
}
